// import mitt from 'mitt';
import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {

    constructor(m) {
        super(m);
    }

    init() {
        
        let self = this;
        const app = createApp({
            data() {
                return {
                    loading: true,
                    siteId: self.el.dataset.siteId,
                    relatedTo: self.el.dataset.relatedTo || null,
                    result: null,
                    fetchTimeout: null,
                    filters: {
                        selectedYears: [],
                        selectedCategories: [],
                        selectedPublics: [],
                        selectedTypes: [],
                        selectedModes: [],
                        searchInput: "",
                    },
                    page: 1,
                    perPage: 12,
                }
            },
            mounted() {
                this.fetchEvents()

                this.$el.parentNode.addEventListener("evenements:search", (event) => {
                    this.filters = event.detail
                });

                
                const urlParams = new URLSearchParams(window.location.search);
                if(urlParams.get('years')?.split(',').filter(Boolean)) this.filters.selectedYears = urlParams.get('years')?.split(',').filter(Boolean);
                if(urlParams.get('categories')?.split(',').filter(Boolean)) this.filters.selectedCategories = urlParams.get('categories')?.split(',').filter(Boolean);
                if(urlParams.get('publics')?.split(',').filter(Boolean)) this.filters.selectedPublics = urlParams.get('publics')?.split(',').filter(Boolean);
                if (urlParams.get('types')?.split(',').filter(Boolean)) this.filters.selectedTypes = urlParams.get('types')?.split(',').filter(Boolean);
                if (urlParams.get('modes')?.split(',').filter(Boolean)) this.filters.selectedModes = urlParams.get('modes')?.split(',').filter(Boolean);
                if(urlParams.get('s')) this.filters.searchInput = urlParams.get('s');

                
                const pageParam = parseInt(urlParams.get('page'), 10);
                if (!isNaN(pageParam) && pageParam > 0) {
                    this.page = pageParam;
                }

                if(this.relatedTo) {
                    this.filters.selectedCategories.push(this.relatedTo);
                }
            },
            watch: {
                filters: {
                    handler(newVal, oldVal) {
                        this.fetchEvents(true);
                    },
                    deep: true
                },
                page() {
                    const currentUrl = new URL(window.location.href);
                    let pathName = currentUrl.pathname.replace(/(p\d)/, '');
                    let query = '';
                    if (this.filters.selectedYears?.length > 0) {
                        query += 'years=' + this.filters.selectedYears.join(',') + '&';
                    }
                    if (this.filters.selectedCategories?.length > 0) {
                        query += 'categories=' + this.filters.selectedCategories.join(',') + '&';
                    }
                    if (this.filters.selectedPublics?.length > 0) {
                        query += 'publics=' + this.filters.selectedPublics.join(',') + '&';
                    }
                    if (this.filters.selectedTypes?.length > 0) {
                        query += 'types=' + this.filters.selectedTypes.join(',') + '&';
                    }
                    if (this.filters.selectedModes?.length > 0) {
                        query += 'modes=' + this.filters.selectedModes.join(',') + '&';
                    }
                    if (this.filters.searchInput) {
                        query += 's=' + this.filters.searchInput + '&';
                    }
                    query += 'page=' + this.page;
                    const newUrl = currentUrl.origin + pathName + '?' + query;
                    window.history.pushState({ path: newUrl }, '', newUrl);
                }
            },
            computed: {
                pageEntries() {
                    let entries = [];

                    if (this.result && this.result.eventsData) {
                        let start = (this.page - 1) * this.perPage;
                        let end = start + this.perPage;

                        entries = this.result.eventsData.slice(start, end);
                    }
                    return entries;
                },
                pageCount() {
                    if (this.result && this.result.eventsData) {
                        return Math.ceil(this.result.eventsData.length / this.perPage);
                    }
                    return 0;
                },
                isFiltered() {
                    return this.filters.selectedYears.length > 0 || this.filters.selectedCategories.length > 0 || this.filters.searchInput.length > 0;
                },
                featuredEvents() {
                    let entries = [];
                    if (this.isFiltered || !this.result) return entries;

                    this.result.eventsData.forEach((event) => {
                        if (entries.length >= 3 || !event.featured) return;
                        if (entries.find(e => e.id === event.id)) return false;
                        entries.push(event);
                    })
                    return entries.slice(0, 3);
                }
            },
            methods: {
                
                fetchEvents(resetPage = false) {
                    
                    this.loading = true
                    document.body.classList.add('blog-loading');

                    if (this.fetchTimeout) {
                        clearTimeout(this.fetchTimeout);
                    }
                    this.fetchTimeout = setTimeout(() => {
                        
                        let url = '/api/evenements/get';
                        let formData = new FormData();

                        formData.append('siteId', this.siteId);

                        if (this.filters.searchInput) {
                            formData.append('s', this.filters.searchInput);
                        }
                        if (this.filters.selectedCategories?.length > 0) {
                            formData.append('categories', this.filters.selectedCategories.join(','));
                        }
                        if (this.filters.selectedYears?.length > 0) {
                            formData.append('years', this.filters.selectedYears.join(','));
                        }
                        if (this.filters.selectedPublics?.length > 0) {
                            formData.append('publics', this.filters.selectedPublics.join(','));
                        }
                        if (this.filters.selectedTypes?.length > 0) {
                            formData.append('types', this.filters.selectedTypes.join(','));
                        }
                        if (this.filters.selectedModes?.length > 0) {
                            formData.append('modes', this.filters.selectedModes.join(','));
                        }
                        
                        fetch(url, {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                            }
                        })
                        .then(response => response.json())
                        .then(data => {
                            this.result = data

                            document.querySelectorAll(".js-events-results-count").forEach((el) => {
                                el.innerHTML = this.result.eventsData.length;
                            })
                        })
                        .finally(() => {
                            this.loading = false

                            document.body.classList.remove('blog-loading');

                            let query = '';
                            if (this.filters.selectedYears?.length > 0) {
                                query += 'years=' + this.filters.selectedYears.join(',') + '&';
                            }
                            if (this.filters.selectedCategories?.length > 0) {
                                query += 'categories=' + this.filters.selectedCategories.join(',') + '&';
                            }
                            if (this.filters.selectedPublics?.length > 0) {
                                query += 'publics=' + this.filters.selectedPublics.join(',') + '&';
                            }
                            if (this.filters.selectedTypes?.length > 0) {
                                query += 'types=' + this.filters.selectedTypes.join(',') + '&';
                            }
                            if (this.filters.selectedModes?.length > 0) {
                                query += 'modes=' + this.filters.selectedModes.join(',') + '&';
                            }
                            if (this.filters.searchInput) {
                                query += 's=' + this.filters.searchInput + '&';;
                            }
                            if (this.page > 1) {
                                query += 'page=' + this.page;
                            }
                            const currentUrl = new URL(window.location.href);
                            let pathName = currentUrl.pathname;
                            pathName = pathName.replace(/(p\d)/, '');
                            const newUrl = currentUrl.origin + pathName + '?' + query;
                            window.history.pushState({path:newUrl},'',newUrl);
                            
                            if (resetPage) {
                                this.page = 1;
                            }
                        })

                    }, 500);

                },

            }
        })
        // app.config.globalProperties.emitter = mitt()

        app.mount(self.el)
    }

}